import { AsideMenuItem } from './AsideMenuItem';
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../setup/index';
import { userHasAllRoles, userHasAnyRole } from 'app/utilities/validateRole';

/**
 * RHCOL = Recursos Humanos - Colaborador
 * CNCDN = Calculo de Nomina - Carga de Nomina
 * CNNOM = Calculo de Nomina - Nomina
 * CNAJU = Calculo de Nomina - Ajustes
 * CNADB = Calculo de Nomina - Asignacion de bonos
 * CNCOM = Calculo de Nomina - Comisiones
 * CNBON = Calculo de Nomina - Bonos
 * CNFDE = Configuracion - Departamentos
 * CNFPD = Configuracion - Percepciones Deducciones
 * CNFR = Configuracion - Roles
 * CNFPE = Configuracion - Perfiles
 * CNFU = Configuracion - Usuarios
 */

export function AsideMenuMain() {

  const screens = useSelector((state: RootState) => state.auth.screens);

  const codes: string[] = screens?.map((item: any) => item.code) ?? [];

  return (
    <>
      <div className="menu-item">
        <div className="menu-content pt-8 pb-2">
          <span className=" text-gray-600 fw-bolder text-uppercase fs-6 ls-1">
            ERP
          </span>
        </div>
      </div>

      {(userHasAnyRole("RHCOL", codes)) && (
        <AsideMenuItemWithSub
          icon="/media/icons/duotune/communication/com006.svg"
          fontIcon="bi-app-indicator"
          to="/recursos_humanos"
          title="Recursos Humanos"
          hasBullet={false}
        >
          <AsideMenuItem
            icon="/media/icons/duotune/general/gen008.svg"
            to="/recursos_humanos/colaboradores"
            title="Mis Colaboradores"
          />
        </AsideMenuItemWithSub>
      )}

      {(userHasAnyRole(['CNCDN', 'CNNOM', 'CNAJU', 'CNADB', 'CNCOM', 'CNBON'], codes)) && (
        <AsideMenuItemWithSub
          icon="/media/icons/duotune/coding/cod002.svg"
          fontIcon="bi-app-indicator"
          to="/configuracion"
          title="Carga de Nómina"
          hasBullet={false}
        >
          {userHasAllRoles("CNCDN", codes) && (
            <AsideMenuItem
              icon="/media/icons/duotune/general/gen005.svg"
              to="/configuracion/carga-de-nomina"
              title="Carga de nómina"
            />
          )}

          {userHasAllRoles("CNNOM", codes) && (
            <AsideMenuItem
              icon="/media/icons/duotune/general/gen008.svg"
              to="/configuracion/nomina"
              title="Nómina"
            />
          )}

          {userHasAllRoles("CNAJU", codes) && (
            <AsideMenuItem
              icon="/media/icons/duotune/general/gen002.svg"
              to="/configuracion/ajuste"
              title="Ajustes"
            />
          )}

          {userHasAllRoles("CNADB", codes) && (
            <AsideMenuItem
              icon="/media/icons/duotune/general/gen003.svg"
              to="/configuracion/asignacion-bonos"
              title="Asignacion de bonos"
            />
          )}

          {userHasAllRoles("CNCOM", codes) && (
            <AsideMenuItem
              icon="/media/icons/duotune/general/gen004.svg"
              to="/configuracion/comisiones"
              title="Comisiones"
            />
          )}

          {userHasAllRoles("CNBON", codes) && (
            <AsideMenuItem
              icon="/media/icons/duotune/general/gen004.svg"
              to="/configuracion/historial"
              title="Bonos"
            />
          )}
        </AsideMenuItemWithSub>
      )}

      {(userHasAnyRole(['CNFDE', 'CNFPD', 'CNFR', 'CNFPE', 'CNFU'], codes)) && (
        <AsideMenuItemWithSub
          icon="/media/icons/duotune/coding/cod001.svg"
          fontIcon="bi-app-indicator"
          to="/ajustes"
          title="Configuración"
          hasBullet={false}
        >
          {userHasAllRoles("CNFDE", codes) && (
            <AsideMenuItem
              icon="/media/icons/duotune/abstract/abs044.svg"
              to="/ajustes/departamentos"
              title="Departamentos"
            />
          )}
          {userHasAllRoles("CNFPD", codes) && (
            <AsideMenuItem
              icon="/media/icons/duotune/finance/fin007.svg"
              to="/ajustes/percepciones-deducciones"
              title="Percepciones - Deducciones"
            />
          )}
          {userHasAllRoles("CNFR", codes) && (
            <AsideMenuItem
              icon="/media/icons/duotune/art/art006.svg"
              to="/ajustes/roles"
              title="Roles"
            />
          )}
          {userHasAllRoles("CNFPE", codes) && (
            <AsideMenuItem
              icon="/media/icons/duotune/coding/cod009.svg"
              to="/ajustes/perfiles"
              title="Perfiles"
            />
          )}
          {userHasAllRoles("CNFU", codes) && (
            <AsideMenuItem
              icon="/media/icons/duotune/communication/com005.svg"
              to="/ajustes/usuarios"
              title="Usuarios"
            />
          )}
        </AsideMenuItemWithSub>
      )}
    </>
  );
}
